import 'babel-polyfill'
import 'react-app-polyfill/ie9'

import { Router, Route, Switch } from 'react-router-dom'
import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'

import registerServiceWorker from 'registerServiceWorker'

import {
  Home,
  JurosSimples,
  JurosCompostos,
  JurosCompostosHeterogenios,
} from 'views'

const customHistory = createBrowserHistory()

ReactDOM.render(
  <Router history={customHistory}>
    <Switch>
      <Route exact path='/' render={props => <Home {...props} />} />
      <Route
        exact
        path='/juros-simples'
        render={props => <JurosSimples {...props} />}
      />
      <Route
        exact
        path='/juros-compostos'
        render={props => <JurosCompostos {...props} />}
      />
      <Route
        exact
        path='/juros-compostos-heterogenios'
        render={props => <JurosCompostosHeterogenios {...props} />}
      />
    </Switch>
  </Router>,
  document.getElementById('root')
)

registerServiceWorker()
